<template>
  <div>
    <div v-if="!hasBeenSubmitted">
      <CRow>
        <CCol>
          <CCard>
            <CCardHeader align="center">
              <h3>Questionnaire</h3>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol sm="4" class="col-sam-1">
                  <label for="category" class="mx-2 custom-label" >Category:</label>
                </CCol>
                <CCol sm="4">
                  <Select id="category" class="form-control" :required="true" v-model="selectedCategory" @change="onChange($event)">
                    <option :selected="true">Choose category</option>
                    <option v-for="item in categories" v-bind:value="item.id">
                      {{item.name}}
                    </option>
                  </Select>
                </CCol>
              </CRow>
              <div class="survey">
                <QuestionsView :questions="questionsList" :readOnly="true" :key="advancedTableKey"/>
                <div v-if="addQuestion">
                  <SurveyBuilder :options="SurveyBuilderJson" :key="advancedTableKey"/>
                </div>
                <div class="pt-10">
                  <button type="button" class="add_another_btn br-25 btn-primary" v-on:click="addNewQuestion()">Add question</button>
                </div>
              </div>
            </CCardBody>
            <CCardFooter>
              <button type="button" class="btn btn-success mx-5" @click="submit()">Finish</button>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </div>
    <div v-if="hasBeenSubmitted">
      <div class="card text-center">
        <div class="card-header">
          <h5>Questionnaire successfully created!</h5>
        </div>
        <div class="card-body">
          <p class="card-text">
            Thank you for submitting your questionnaire. You can check your scores in the Progress meter by downloading the free Chrome extension!
          </p>
        </div>
        <div class="card-footer">
          <button type="button" class="btn btn-primary" v-on:click="gotoCategory">Goto Category</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SurveyBuilder, SurveyBuilderJson } from 'vue-survey-builder';
import QuestionsView from "@/views/questionnaire/QuestionsView";
import axios from "axios";
export default {
  name: 'Survey',
  data() {
    return {
      SurveyBuilderJson,
      questionsList: [],
      addQuestion: false,
      finishStatus: false,
      categories: [],
      selectedCategory: "",
      success: false,
      alertPlaceholder: "",
      advancedTableKey: 0,
      hasBeenSubmitted: false
    };
  },
  mounted() {
    document.title = 'Starter Grower | Questionnaire'
    this.$root.$on('add-update-question', q => {
      this.updateQuestionsList(q);
    });
    this.getCategory();
  },
  components: { SurveyBuilder, QuestionsView },
  methods: {
    updateQuestionsList(question) {
      const questionIndex = this.questionsList.findIndex(x => x.id === question.id);
      if (questionIndex >= 0) {
        this.questionsList.splice(questionIndex, 1, question);
      } else {
        this.questionsList.push(JSON.parse(JSON.stringify(question)));
      }
      this.addQuestion = false;
      this.$root.$emit('selected-question', null);
      window.console.log(question, this.addQuestion, this.questionsList);
    },
    addNewQuestion() {
      this.SurveyBuilderJson = JSON.parse(JSON.stringify(SurveyBuilderJson));
      this.addQuestion = true;
      this.finishStatus = true;
    },
    getCategory() {
      let self = this;
      console.log('in here')
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/categories', {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log(response.data)
        self.categories = response.data.data
      }).catch(function (error) {
        console.log(error);
      });
    },
    submit() {
      let self = this;
      console.log('Question list', self.questionsList)
      console.log(self.selectedCategory)
      const token = localStorage.getItem("api_token")
      axios.post(this.$apiAdress + '/api/questionnaires', {
        data: self.questionsList,
        category_id: self.selectedCategory,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
      .then(function (response) {
        console.log(response.data)
        self.alertPlaceholder = 'Questionnaire';
        self.success = true;
        self.hasBeenSubmitted = true;
        self.resetForm();

        setTimeout(function () {
          self.success = !self.success
        }.bind(this), 5000);
        self.forceRerender()
      }).catch(function (error) {
        console.log(error)
      });
    },
    onChange(event) {
      let self = this;
      console.log(event.target.value)
      self.selectedCategory = event.target.value;
    },
    resetForm() {
      this.selectedCategory = "";
      this.questionsList = [];
      this.finishStatus = false
    },
    forceRerender() {
      console.log(this.advancedTableKey + "====")
      this.advancedTableKey += 1;
      console.log(this.advancedTableKey + "====")
    },
    gotoCategory() {
      let self = this
      self.$router.push({ path: '/list' });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.add_another_btn {
  font-size: 14px;
  /*background-color: transparent;*/
  /*border-color: #4c8ce4;*/
  /*color: #4c8ce4;*/
  padding: 8px;
  cursor: pointer;
}
.text-center {
  text-align: center;
}
.survey {
  margin: 50px;
}
.col-sam-1 {
  max-width: 7%;
}
.custom-label {
  font-weight: bold;
}

</style>
